module.exports = __webpack_public_path__ + "static/media/pc-icon-weixin.3a64f309.svg";